import React, {  Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';

/* Actions */
import {
	createNewBrochure,
	createNewBinderPayload,
	saveBrochuresDetails
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';
let { pdfViewerLocalstorageVar } = routes;

class BrochureStep4 extends Component {

	componentDidMount() {
		window.scrollTo(0, 0);
		if(this.props.state.brochure.selectedItems.length === 0) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}

	goToStep(step, event) {
		event.preventDefault();
		browserHistory.push("/create-brochure-step"+step);
	}

	doServiceCallForBrochure(type, operation, event) {
		event && event.preventDefault();
		var self = this;
		/*new brochure change*/
		let { state } = this.props,
			payload = state.brochure.payload,
			{ templateOptions } = state.brochure;

		//Set username and account number in payload
		payload.brochure.userId = state.user.userDetails && state.user.userDetails.sso;
		//payload.brochure.accountNumber = self.props.getSelectedAccountNumber();
		payload.brochure.selectedFeatureOption = state.brochure.selectedFeatureOption;
		//delete file url from payload
		delete payload.brochure.fileURL;

		//Remove localstorage pdf viewer object if already added
		self.props.removeLocalStorageVar(pdfViewerLocalstorageVar);

		//Update payload for rqeuired currency format
		payload.brochure.pages.map((item, index) => {
			if(item.price !== "") {
				item.price = self.props.formatMoney(item.price, 0, ".", ",")
			} else {
				item.products.map((itm, ind) => {
					itm.price = self.props.formatMoney(itm.price, 0, ".", ",")
					return null;
				})
			}
			if(item.selectedTemplateOption){
				item.selectedTemplateOption = templateOptions.find((template) => template.templateName == item.selectedTemplateOption.templateName);
			}
			return null;
		});
		if(payload.brochure.productInfo){
			payload.brochure.productInfo.hasProductColor='N';
			payload.brochure.productInfo.hasWarrantyInfo='N';
		}
		/*end brochure change*/
		//remove binder from payload
		delete payload.binders;

		payload = payload.brochure;

		// if existing brochure name is there it means its edit brochure
		if (payload.existingBrochureName && payload.brochureName !== payload.existingBrochureName) {
			delete payload.brochureId;
			operation = 'POST';
		}
		//Service call for create brochure
		self.props.createNewBrochure(payload, type === "new"?"requestType=createBrochure":"", type === "new", operation, (response) => {
			if(response.status) {
				if(type === "save")
					browserHistory.push("/brochure/"+(operation === "POST"?"create":"updated")+"/confirmation");
				else {
					self.props.viewPDFViewer(response.responseObject, "Click here to download the brochure");
				}
			} else {
				browserHistory.push("/error");
			}
		});
	}

	// createBinder(event) {
	// 	event.preventDefault();
	// 	this.props.createNewBinderPayload();
	// 	browserHistory.push("/create-binder-step1");
	// }

    render() {
		var self = this;
		let { brochure, user } = this.props.state,
			typeOfUser = user.userDetails.typeOfUser;
			let featureName = brochure.selectedFeatureOption == 1 ? "Feature Name Only" : "Feature Name + Description";
        return (
            <div>
                <div className="push"><h1>{brochure.payload.brochure.brochureId?"Edit":"Create"} Brochure</h1></div>
                <h2 className="pageTitle">Step 4 of 4: Review Brochure Information</h2>
                <div className="clear">
                    <hr />
                    <p><i>Total # of pages (including cover page) = {brochure.payload.brochure.hasCoverPage==="Y"?brochure.payload.brochure.pages.length+1:brochure.payload.brochure.pages.length}</i></p>
                </div>
                <form className="reviewBrochureInformationForm" onSubmit={(e) => e.preventDefault()} name="reviewBrochureInformationForm" id="reviewBrochureInformationForm" action="PUT_FORM_ACTION_URL_HERE">
                    <div className="push headerAndFooterSection">
                        <h3>Header &amp; Footer</h3>
                        <div className="indented">
                            <p><b>Brochure Name:</b> {brochure.payload.brochure.brochureName}</p>
                            <p><b>Logo:</b> {brochure.payload.brochure.customerLogo}</p>
                        </div>
                    </div>
					{brochure.payload.brochure.hasCoverPage==="Y"
	                    ?<div className="push coverPageSection">
	                        <h3>Cover Page</h3>
	                        <div className="indented">
	                            <div className="columns">
	                                <div className="column">
	                                    <h4>For more information:</h4>
										{brochure && brochure.payload.brochure.salesInfo
											?<p>
												{brochure.payload.brochure.salesInfo.name && brochure.payload.brochure.salesInfo.name.trim()}<br />
												{brochure.payload.brochure.salesInfo.email && brochure.payload.brochure.salesInfo.email.trim()}<br />
												{brochure.payload.brochure.salesInfo.address1 && brochure.payload.brochure.salesInfo.address1.trim()}
												{brochure.payload.brochure.salesInfo.address1 && brochure.payload.brochure.salesInfo.address1.trim() !== ""?<br/>:null}
												{brochure.payload.brochure.salesInfo.address2 && brochure.payload.brochure.salesInfo.address2.trim()}
												{brochure.payload.brochure.salesInfo.address2 && brochure.payload.brochure.salesInfo.address2.trim() !== ""?<br/>:null}
												{brochure.payload.brochure.salesInfo.city && brochure.payload.brochure.salesInfo.city.trim()}{brochure.payload.brochure.salesInfo.city && brochure.payload.brochure.salesInfo.city.trim() && ", "}{brochure.payload.brochure.salesInfo.state && brochure.payload.brochure.salesInfo.state.trim()} {brochure.payload.brochure.salesInfo.zipCode && brochure.payload.brochure.salesInfo.zipCode.trim()}<br />
												{brochure.payload.brochure.salesInfo.phone && this.props.normalizePhoneNumber(brochure.payload.brochure.salesInfo.phone.trim())}<br />
											</p>
											:null
										}
	                                </div>
	                                <div className="column">
	                                    <h4>This brochure prepared for:</h4>
										{brochure && brochure.payload.brochure.customerInfo
											?<p>
												{brochure.payload.brochure.customerInfo.name && brochure.payload.brochure.customerInfo.name.trim()}
												{brochure.payload.brochure.customerInfo.name && brochure.payload.brochure.customerInfo.name.trim() !== ""?<br/>:null}
												{brochure.payload.brochure.customerInfo.address1 && brochure.payload.brochure.customerInfo.address1.trim()}
												{brochure.payload.brochure.customerInfo.address1 && brochure.payload.brochure.customerInfo.address1.trim() !== ""?<br/>:null}
												{brochure.payload.brochure.customerInfo.address2 && brochure.payload.brochure.customerInfo.address2.trim()}
												{brochure.payload.brochure.customerInfo.address2 && brochure.payload.brochure.customerInfo.address2.trim() !== ""?<br/>:null}
												{brochure.payload.brochure.customerInfo.city && brochure.payload.brochure.customerInfo.city.trim()}{brochure.payload.brochure.customerInfo.city && brochure.payload.brochure.customerInfo.city.trim() && ", "}{brochure.payload.brochure.customerInfo.state && brochure.payload.brochure.customerInfo.state.trim()} {brochure.payload.brochure.customerInfo.zipCode && brochure.payload.brochure.customerInfo.zipCode.trim()}<br />
												{brochure.payload.brochure.customerInfo.phone && this.props.normalizePhoneNumber(brochure.payload.brochure.customerInfo.phone.trim())}<br />
											</p>
											:null
										}
	                                </div>
	                            </div> {/* / .columns */}
	                            <pre className="additionalInfo">{brochure.payload.brochure.salesInfo.additionalInfo}</pre>
	                        </div>
	                    </div>
						:null
					}
                    <div className="push">
                        <p><a className="withIcon withEditIcon noUnderline bold uppercase" href="" onClick={this.goToStep.bind(this, 3)}>Edit Brochure Information</a></p>
                    </div>
                    <div className="push">
                        <div className="push">
                            <h3 className="noMarginBottom">Product Pages</h3>
							<p className="noMarginTop"><i>Will include product description, photos, features, feature descriptions if selected.</i></p>
                        </div>
						<div className="indented">
						<h2 className="noMarginBottom">{featureName}</h2>
						</div>
						{brochure.payload.brochure.pages.map((item, index) => {
							return <div className="indented push productPageReview" key={index}>
								<h2 className="pageNumberTitle"> Brand Divider Selected: <span className="unbold">{item.selectedBrochureDividerTemplate.dividerTemplateName}</span></h2>
								{brochure.payload.brochure.priceLevel === "PagePrice"
									?[<div className="float floatLeft" style={{display:"flex"}} key={0}>
										<h4 className="pageNumberTitle">Page {item.pageNumber}: <span className="unbold">{item.pageTitle}</span></h4>
										{item.selectedTemplateOption && <h4 className="pageNumberTitle" style={{marginLeft: "150px"}}>Template Selected: <span className="unbold">{item.selectedTemplateOption.templateName}</span></h4>}
									</div>,<div className="float floatRight" key={1}>
										<p className="pagePrice"><b>Page price:</b> {self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</p>
									</div>,<div className="clear" key={2}></div>]
									:
									<div style={{display:"flex"}}>
									<h4 className="pageNumberTitle">Page {item.pageNumber}: <span className="unbold">{item.pageTitle}</span></h4>
									{item.selectedTemplateOption && <h4 className="pageNumberTitle" style={{marginLeft: "150px"}}>Template Selected: <span className="unbold">{item.selectedTemplateOption.templateName}</span></h4>}
									</div>
								}
	                            <table className="productPageReviewTable dataTableType2">
	                                <thead>
	                                    <tr>
	                                        <th className="product">Products</th>
	                                        <th className="description">Description</th>
	                                        <th className="price">{brochure.payload.brochure.priceLevel === "ProductPrice"?"Price":null}</th>
	                                    </tr>
	                                </thead>
	                                <tbody>
										{item.products.map((itm, ind) => {
											return <tr key={ind}>
		                                        <td className="product"><Link className="sku" to={'/product-specs/product-number/'+itm.productNumber}>{itm.productNumber}</Link></td>
		                                        <td className="description">{itm.productName}</td>
		                                        <td className="price" style={{textAlign: 'right'}}>{brochure.payload.brochure.priceLevel === "ProductPrice"?self.props.formatMoney(itm.price, 0, ".", ",", false, "$"):null}</td>
		                                    </tr>
										})}
	                                </tbody>
	                            </table>
	                            <p><a className="withIcon withEditIcon noUnderline bold uppercase" href="" onClick={this.goToStep.bind(this, 1)}>Edit / Reorder Pages</a></p>
	                        </div>
						})}
                    </div>
                     {/* <div className="push"> 
                        <h3>Warranty Pages</h3>
                        <p>Contains an overview of the written warranties offered on various Hotpoint, GE, GE Profile Series, GE Cafe Series, and GE Monogram appliances described in this brochure for products manufactured on or after January 1, 2006.</p>
                    </div>*/}
                    <div className="floatLeft">
                        <input
							value={
								(brochure.payload.brochure.brochureId && brochure.payload.brochure.existingBrochureName && brochure.payload.brochure.brochureName === brochure.payload.brochure.existingBrochureName ?"Update":"Save") + " for Later"
							}
							onClick={this.doServiceCallForBrochure.bind(this, "save", (brochure.payload.brochure.brochureId?"PUT":"POST"))}
							type="submit"
						/>
                    </div>
                    <div className="floatRight">
						<input value="Create Brochure" onClick={this.doServiceCallForBrochure.bind(this, "new", "POST")} type="submit" />
                    </div>
				{/* typeOfUser === "employee"
						?<div className="floatRight" style={{marginRight: 20}}>
							<input defaultValue="Create Binder" onClick={this.createBinder.bind(this)} type="submit" />
	                    </div>
						 :null
					} */}
                    <div className="clear" />
                </form>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createNewBrochure: (payload, hybridQueryParams, useBootAPI, operation, callback) => dispatch(createNewBrochure(payload, hybridQueryParams, useBootAPI, operation, callback)),
	createNewBinderPayload: () => dispatch(createNewBinderPayload()),
	saveBrochuresDetails: (payload) => dispatch(saveBrochuresDetails(payload))
});

BrochureStep4 = connect(mapStateToProps, mapDispatchToProps)(BrochureStep4);
export default BrochureStep4;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/step4.js